import React from 'react';
import { withRouter } from 'react-router';
import CompareForm from './CompareForm';


class IdentityEdit extends React.Component {
    constructor(props){
        super(props);
        this.id = props.match.params.id;
    }

    render(){
        return (
            <div>
                <CompareForm id={this.id} />
            </div>
        );
    }

}
export default withRouter(IdentityEdit);



// WEBPACK FOOTER //
// ./src/pages/CompareScenes/CompareEdit.js